import { createStyles, Theme } from '@material-ui/core';

const drawerWidth = 240;

export const styles = (theme: Theme) =>
  createStyles({
    drawerPaper: {
      pointerEvents: 'none',
      marginTop: '49px',
      flexShrink: 0,
      whiteSpace: 'nowrap',
      boxShadow: 'none',
      overflowX: 'hidden',
      width: theme.spacing(6.5),
      top: '-1px',
      left: '-1px',
      transition: `${theme.transitions.create(['width'], {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.shortest
      })} !important`,
      '&.drawerPaper--closed': {
        pointerEvents: 'auto',
        width: theme.spacing(6.5)
      },
      '&.drawerPaper--open': {
        pointerEvents: 'auto',
        width: drawerWidth
      }
    },
    sideNavContainer: {
      width: '100%',
      height: 'calc(100% - 49px)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    },
    sideNav: {
      width: '100%'
    },
    navList: {
      width: drawerWidth,
      overflowY: 'auto',
      marginLeft: 0
    },
    menuItem: {
      width: drawerWidth
    },
    menuItemIcon: {
      color: theme.palette.secondary.main
    }
  });
